import React from 'react'

type Props = {
  size?: number
  fill?: string
  stroke?: string
}

export const ChatIconFavorite = ({
  size = 20,
  fill = '#FF5454',
  stroke,
}: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.1186 4.23193C16.2358 3.41257 15.0675 2.97097 13.8633 3.00148C12.6592 3.032 11.5148 3.53221 10.6745 4.39525L9.99406 5.07572L9.31359 4.39525C8.47436 3.53578 7.33302 3.03752 6.13218 3.00638C4.93134 2.97525 3.76571 3.4137 2.88309 4.22853C2.45091 4.64473 2.10602 5.1429 1.86858 5.69392C1.63114 6.24494 1.50591 6.83776 1.5002 7.43773C1.4945 8.03771 1.60844 8.6328 1.83537 9.18823C2.06229 9.74367 2.39765 10.2483 2.82184 10.6726L9.48371 17.3481C9.61944 17.4827 9.80288 17.5583 9.99406 17.5583C10.1852 17.5583 10.3687 17.4827 10.5044 17.3481L17.1765 10.676C17.6009 10.2519 17.9365 9.74747 18.1637 9.19216C18.3909 8.63685 18.5052 8.04182 18.4998 7.44185C18.4944 6.84188 18.3695 6.24899 18.1324 5.69785C17.8952 5.14671 17.5506 4.64836 17.1186 4.23193Z"
        fill={fill}
        stroke={stroke}
      />
    </svg>
  )
}
